'use client';

import { useDispatchOnce } from '@/hooks/use-dispatch-once';
import { useAnalytics } from '@/lib/analytics/use-analytics';

import { useCampaign } from '../_campaigns/use-campaign';

export default function GiftHeader() {
  const { Header, campaignName } = useCampaign();
  const { track } = useAnalytics();

  useDispatchOnce(() => {
    if (campaignName) {
      track('gift_campaign_viewed', { campaign_name: campaignName });
    }
  });

  return <Header />;
}
